import React, { ReactNode } from 'react'
import { Card } from '@tecsinapse/cortex-react'
import { t } from '@lingui/core/macro'
import { IoAlertCircleOutline } from 'react-icons/io5'

interface EmptyListProps {
  title?: string
  subTitle?: string
  Icon?: ReactNode
}

export const EmptyList = ({
  title = t`Nada por aqui`,
  subTitle = t`Não existem dados para exibição.`,
  Icon = <IoAlertCircleOutline size={48} />
}: EmptyListProps) => {
  return (
    <Card className={'flex flex-1'}>
      <div className={'flex flex-1 items-center justify-center flex-col'}>
        {Icon}
        <p className={'font-bold text-h3 mt-deca'}>{title}</p>
        {subTitle ? <p className={'text-h4'}>{subTitle}</p> : <></>}
      </div>
    </Card>
  )
}
